export const AuthSecret = new URLSearchParams(window.location.search).get('auth_secret');
